"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Service_1 = require("../Service");
var Util_1 = require("../../Utils/Util");
/**
 * Represents the BotlistMe service.
 * @see https://docs.botlist.me
 */
var BotlistMe = /** @class */ (function (_super) {
    __extends(BotlistMe, _super);
    function BotlistMe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BotlistMe, "aliases", {
        /** The values that can be used to select the service. */
        get: function () {
            return ['botlistme', 'botlist.me'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotlistMe, "logoURL", {
        /** The logo URL. */
        get: function () {
            return 'https://botlist.me/icon.png';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotlistMe, "serviceName", {
        /** Service's name. */
        get: function () {
            return 'BotlistMe';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotlistMe, "websiteURL", {
        /** The website URL. */
        get: function () {
            return 'https://botlist.me/';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotlistMe, "baseURL", {
        /** The base URL of the service's API. */
        get: function () {
            return 'https://api.botlist.me/api/v1';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Posts statistics to this service.
     * <warn>Shard data posting is not supported for this service.</warn>
     * @param options The options of the request.
     */
    BotlistMe.post = function (options) {
        var token = options.token, clientID = options.clientID, serverCount = options.serverCount;
        return _super._post.call(this, {
            method: 'post',
            url: "/bots/".concat(Util_1.Util.resolveID(clientID), "/stats/"),
            headers: { Authorization: token },
            data: { server_count: Util_1.Util.resolveCount(serverCount) }
        });
    };
    /**
     * Gets whether a user has voted for a bot.
     * @param botID The bot's ID.
     * @param userID The user's ID.
     */
    BotlistMe.prototype.userVoted = function (botID, userID) {
        return this._request({
            url: "/bots/".concat(Util_1.Util.resolveID(botID), "/voted"),
            headers: { Authorization: this.token },
            params: { user_id: Util_1.Util.resolveID(userID) }
        }, { requiresToken: true });
    };
    return BotlistMe;
}(Service_1.Service));
exports.default = BotlistMe;
